module.exports = __webpack_public_path__ + "static/media/home-bannerold.9bb91582.png";